import { render, staticRenderFns } from "./DisciplinePicker.vue?vue&type=template&id=44a0161a&scoped=true"
import script from "./DisciplinePicker.vue?vue&type=script&lang=js"
export * from "./DisciplinePicker.vue?vue&type=script&lang=js"
import style0 from "./DisciplinePicker.vue?vue&type=style&index=0&id=44a0161a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0161a",
  null
  
)

export default component.exports